import './index.css';
import { topbar } from "../components/topbar";
import file from '../malaka talablari/files/xalq_talablari.pdf';
import imgbook from '../../images/book.png';

export default function Oquv_reja(){
    
    const davolash = [
        {'text': 'Xalq tabobati 1 kurs', 'year': '2022-2023', 'book': file},
        {'text': 'Davolash ishi 1 kurs', 'year': '2022-2023', 'book': file},
        {'text': 'Xalq tabobati 2 kurs', 'year': '2021-2022', 'book': file},
        {'text': 'Xalq tabobati 3 kurs', 'year': '2020-2021', 'book': file},
        {'text': 'Davolash ishi 3 kurs', 'year': '2020-2021', 'book': file},
        {'text': 'Davolash ishi 4 kurs', 'year': '2019-2020', 'book': file},
        {'text': 'Kasb ta`limi (Davolash ishi) 6 kurs', 'year': '2017-2018', 'book': file},
    ];

    const davolashxml = davolash.map((data) => 
        <a href={data.book}>
            <nav className='file-box'>
                <img class="file-img" src={imgbook} alt="file.png"/>
                <p className='file-text'>{data.year} <br/> {data.text}</p>
            </nav>
        </a>
    );

    const stom = [
        {'text': 'Stomatologiya 1 kurs', 'year': '2022-2023', 'book': file},
        {'text': 'Stomatologiya 2 kurs', 'year': '2021-2022', 'book': file},
        {'text': 'Stomatologiya 3 kurs', 'year': '2020-2021', 'book': file},
        {'text': 'Stomatologiya 4 kurs', 'year': '2019-2020', 'book': file},
        {'text': 'Stomatologiya 5 kurs', 'year': '2018-2019', 'book': file},
    ];

    const stomxml = stom.map((data) => 
        <a href={data.book}>
            <nav className='file-box'>
                <img class="file-img" src={imgbook} alt="file.png"/>
                <p className='file-text'>{data.year} <br/> {data.text}</p>
            </nav>
        </a>
    );

    const bstom = [
        {'text': 'Bolalar stomatologiyasi 1 kurs', 'year': '2022-2023', 'book': file},
        {'text': 'Bolalar stomatologiyasi 2 kurs', 'year': '2021-2022', 'book': file},
        {'text': 'Bolalar stomatologiyasi 3 kurs', 'year': '2020-2021', 'book': file},
        {'text': 'Bolalar stomatologiyasi 4 kurs', 'year': '2019-2020', 'book': file},
        {'text': 'Bolalar stomatologiyasi 5 kurs', 'year': '2018-2019', 'book': file},
    ];

    const bstomxml = bstom.map((data) => 
        <a href={data.book}>
            <nav className='file-box'>
                <img class="file-img" src={imgbook} alt="file.png"/>
                <p className='file-text'>{data.year} <br/> {data.text}</p>
            </nav>
        </a>
    );

    const divider = (fakultet) => {

        return(
            <p className='div-fakultet'>{fakultet}</p>
        );
    }

    return(
        <div className="oquv_reja">
            
            {topbar('O`quv rejalar', 'o`quv rejalar')}
            
            <div className="content">
                <br/><br/>
                {divider('Stomotologiya fakulteti')}
            
                <div className='fakulty-box'>
                    {stomxml}
                </div>

                {divider('Bolalar stomotologiyasi fakulteti')}
                
                <div className='fakulty-box'>
                    {bstomxml}
                </div>
                
                
                {divider('Davolash ishi fakulteti')}
                
                <div className='fakulty-box'>
                    {davolashxml}
                </div>
            
            </div>
        </div>
    )
}